import axios from "axios";
import Datasource from "lib/datasource";
import { memoAC } from "./memoize";
import { getAuthTokenFromCookie } from "lib/hooks";

const headers = () => ({
	"Content-Type": "application/json",
	Authorization: `Bearer ${getAuthTokenFromCookie()}`
});

export const getSignersForCondition = memoAC((conditionId: string) => (dispatch: any) => {
	dispatch({ type: "GET_SIGNERS_REQUEST" });
	axios.get(`${process.env.REACT_APP_API_ENDPOINT_V2}conditions/${conditionId}/signers`, { headers: headers() })
		.then((res) => {
			const signers = Datasource.getNormalizedData(res.data, "signer");
			dispatch({ type: "GET_SIGNERS_SUCCESS", response: { status: 200 }, resource: signers });
		})
		.catch((e) => { dispatch({ type: "GET_SIGNERS_FAILED", response: e }); });
});

export const getSigner = memoAC((id: string) => (dispatch: any) => {
	dispatch({ type: "GET_SIGNER_REQUEST" });
	axios.get(`${process.env.REACT_APP_API_ENDPOINT_V2}signers/${id}`, { headers: headers() })
		.then((res) => {
			const signer = Datasource.getNormalizedData(res.data, "signer");
			dispatch({ type: "GET_SIGNER_SUCCESS", response: { status: 200 }, resource: signer });
		})
		.catch((e) => { dispatch({ type: "GET_SIGNER_FAILED", response: e }); });
});

export const signAsSigner = memoAC((id: string, signatureDocumentId?: string, note?: string) => (dispatch: any) => {
	dispatch({ type: "POST_SIGNER_SIGN_REQUEST" });
	return axios.post(
		`${process.env.REACT_APP_API_ENDPOINT_V2}signers/${id}/sign`,
		{ signature_document_id: signatureDocumentId, note },
		{ headers: headers() }
	)
		.then((res) => {
			const signer = Datasource.getNormalizedData(res.data, "signer");
			dispatch({ type: "POST_SIGNER_SIGN_SUCCESS", response: { status: 200 }, resource: signer });
			return signer;
		})
		.catch((e) => { dispatch({ type: "POST_SIGNER_SIGN_FAILED", response: e }); throw e; });
});

export const declineAsSigner = memoAC((id: string, note?: string) => (dispatch: any) => {
	dispatch({ type: "POST_SIGNER_DECLINE_REQUEST" });
	axios.post(`${process.env.REACT_APP_API_ENDPOINT_V2}signers/${id}/decline`, { note }, { headers: headers() })
		.then((res) => {
			const signer = Datasource.getNormalizedData(res.data, "signer");
			dispatch({ type: "POST_SIGNER_DECLINE_SUCCESS", response: { status: 200 }, resource: signer });
		})
		.catch((e) => { dispatch({ type: "POST_SIGNER_DECLINE_FAILED", response: e }); });
});
